import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height:350px;
    overflow: hidden;
    width:100%;

    ${mq(Devices.mobile)} {
        min-height:unset;
        aspect-ratio: unset;
    }
`;

export const TooltipContainer = styled.div`
    position: absolute;
    top:10px;
    left:10px;
    width:32px; 
    height:32px;
`;

export const Export = styled.button`    
    border-radius: 20px;
    background-color: #2A848E;
    position: absolute;
    top:10px;
    right:10px;
    color:#fff;
    height:36px;
    width:36px;
    padding:8px;
    transition: all 0.2s ease-in-out;

    svg{
        height:100%;
        path{
            fill:#fff;
        }
    }

    :hover{
        background-color: #2a848ecc;
    }
`;

export const Pin = styled(Export)<{active?:boolean, left?:number, top?:boolean, translatey?:boolean}>`    
    background-color: #bbbbbb;
    padding:8px;
    left: unset;
    top: unset;
    right:unset;
    color:#fff;
    height:32px;
    width:32px;
    display:flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    opacity: ${props => props.active?"1":"0.6"};
    z-index: 4;
    transform: ${props => props.translatey?"translateY(-50%)":""};

    svg{
        height:100%;
    }

    :hover{
        background-color: #bbbbbb;
        opacity:1;
    }

    ${mq(Devices.mobile)} {
        left: ${props => props.left?"unset":"10px"};
        right:14px;
    }
`;

export const AbsenceContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height:100%;
    z-index: 10;

    span{
        letter-spacing: -5px;
        font-size: 110px;
        line-height: 110px;
        font-weight: 700;
    }
    p{
        font-size: 30px;
    }
`;

export const AbsencePraise = styled.div`
    display: flex;
    justify-content: space-between;
    padding:15px;
    z-index: 2;

    p{
        font-size: 16px;
        font-weight: 600;
        text-transform: uppercase;
    }
`;